<template>
  <b-modal id="modal-respon" title="Respon PPFTZ" variant="success" ref="modalRespon" hide-footer no-close-on-esc>
    <loading :active.sync="this.$store.state.barpin.isLoadingModal" :is-full-page="false"></loading>
    <table class="table table-bordered table-responsive">
      <tr v-if="$store.state.barpin.respon.status > '100'">
        <td>Respon Penerimaan</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/penerimaan/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>

      <tr v-if="$store.state.barpin.respon.status > '100'">
        <td>PPFTZ</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/ppftz/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>
      <tr v-if="$store.state.barpin.respon.status > '110' && this.$store.state.barpin.files.file_billing">
        <td>Kode Billing</td>
        <td> <a target="_blank" v-if="this.$store.state.barpin.files.file_billing"
            :href="`${ this.$http.options.base }/file/ppftz/${ this.$store.state.barpin.header.no_aju }/${ this.$store.state.barpin.files.file_billing }`">
            <b-button variant="success">
              <i class="fa fa-download"></i>
            </b-button>
          </a></td>
      </tr>
      <tr v-if="$store.state.barpin.respon.status > '116'">
        <td>SURAT PEMERIKSAAN FISIK (SPF)</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/spf/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>
      <tr v-if="$store.state.barpin.respon.status > '116'">
        <td>Instruksi Pemeriksaan (IP)</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/ip/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>
      <tr v-if="$store.state.barpin.respon.status >= '150'">
        <td>SPPB</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/sppb/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>
      <tr v-if="$store.state.barpin.respon.status == '145'">
        <td>NOTA PENOLAKAN</td>
        <td><a target="_blank" :href="$http.options.root + '/ppftz/pdf/nolak/' + $store.state.barpin.respon.id">
            <b-button variant="success"><i class="fa fa-download"></i></b-button>
          </a></td>
      </tr>
    </table>
  </b-modal>
</template>
<script>
import {mapActions} from 'vuex'
// import swal from 'sweetalert'
export default {
  data () {
    return {
      responses: []
    }
  },
  methods: {
    ...mapActions({
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalRespon.vue?73a5f93e